import { B2bErrorCode, PolicyId } from '@estercare/ester-shared'
import { appConfig } from '../../../../config'

export class PolicyVersionOutdatedError extends Error {}

export const acknowledgePolicy = async ({
  policyId,
  version,
  language,
  accessToken,
}: {
  policyId: PolicyId
  version: string
  language: string
  accessToken: string
}): Promise<Response> => {
  const response = await fetch(`${appConfig.serverRootUrl}/api/private/policies/${policyId}/acknowledge`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ version, language }),
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    if (response.status === 409 && data?.code === B2bErrorCode.POLICY_VERSION_OUTDATED) {
      throw new PolicyVersionOutdatedError(data.message)
    }
    throw new Error(data?.message || `Failed to acknowledge policy ${policyId}`)
  }
  return response
}

export const declinePolicy = async ({
  policyId,
  accessToken,
}: {
  policyId: PolicyId
  accessToken: string
}): Promise<Response> => {
  const response = await fetch(`${appConfig.serverRootUrl}/api/private/policies/${policyId}/decline`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data?.message || `Failed to decline policy ${policyId}`)
  }
  return response
}
